




























































































import Vue from 'vue'
import { mapGetters } from 'vuex'
import UploadFile from './components/UploadFile.vue'
import CurrentFileTab from './components/CurrentFileTab.vue'
import TransportLogTable from './components/TransportLogTable.vue'
import TurnAroundDoc from './components/TurnAroundDoc.vue'
import {
  TransferDirectoryGroupServiceProxy,
  TransferDirectoryQueryServiceProxy
} from '@/service-proxies/app-v2/dnc.service-proxies'

const transferDirectoryGroupServiceProxy = new TransferDirectoryGroupServiceProxy()
const transferDirectoryQueryServiceProxy = new TransferDirectoryQueryServiceProxy()
const rootTreeItem: any = [{
  title: 'page_transport_directory_group',
  id: '0',
  key: '0',
  value: '0',
  data: { allPath: '/0', id: '0', name: 'page_transport_directory_group' },
  children: []
}]
export default Vue.extend({
  components: { UploadFile, CurrentFileTab, TransportLogTable, TurnAroundDoc },
  data() {
    return {
      loading: false,
      fileLimit: 20,
      treeData: [], // 下拉树数据（设备目录分组）
      selectNode: '', // 选中的节点
      selectDirectory: {},  // 选中的设备目录
      activeTab: '1',
      // rootTreeItem,
      dirList: [], // 工位文件
      loadingDirListData: false,
      uploadModalVisible: false,
      showHeaderAction: true,
      turnAroundDoc: [], // 回传文件
    }
  },
  computed: {
    ...mapGetters(['buttons']),
    rootTreeItem() {
      return rootTreeItem.map((item: any) => {
        return {
          ...item,
          title: this.$t(item.title),
          data: { allPath: '/0', id: '0', name: this.$t(item.title) }
        }
      })
    },
    checkedDirectoryIds() { // 勾选的目录id集合
      let arr = []
      this.dirList.filter(dir => !!(dir.checked)).map(item => arr.push(item.id))
      return arr
    }
  },
  watch: {
    treeData: {
      handler(val) {
        if (val.length) {
          this.selectGroup('0')
        }
      },
      deep: true
    },
    buttons: {
      handler(val) {
        let btn1 = 'page_transport_directory_upload'
        this.showHeaderAction = !!(val.includes(btn1))
      },
      immediate: true,
      deep: true
    },
    selectDirectory:{
      handler(val) {
        this.activeTab = '1'
      }
    }
  },
  created() {
    /*this.rootTreeItem.map((item: any) => {
      item.title = this.$t('page_transport_directory')
      item.data.name = this.$t('page_transport_directory')
    })*/
    this.getTreeData()
  },
  methods: {
    getTreeData() {
      transferDirectoryGroupServiceProxy.treeList().then(res => {
        if (res && res.length) {
          this.rootTreeItem[0].children = this.handleTreeData(res)
        }
        this.treeData = this.rootTreeItem
      })
    },
    handleTreeData(data: any) {
      data.map((item: any) => {
        item = Object.assign(item, { key: item.id, value: item.id })
        if (item.children.length) {
          this.handleTreeData(item.children)
        }
      })
      return data
    },
    // 选择分组
    selectGroup(value: any) {
      this.selectNode = value
      this.getDirectoryList()
    },
    // 处理树结构
    createNode(item: any) {
      const children = item.children

      const node = {
        key: item.id,
        value: item.id,
        title: item.title,
        children: children
      }

      if (children != null) {
        const length = children.length
        if (length > 0) {
          const childrenList = []
          for (let i = 0; i < length; i++) {
            childrenList[i] = this.createNode(children[i])
          }

          node.children = childrenList
        }
      }
      return node
    },
    // 获取组下面的所有工位文件
    getDirectoryList() {
      this.loadingDirListData = true
      transferDirectoryQueryServiceProxy.list(this.selectNode).then((res: any) => {
        if (res && res.length) {
          this.dirList = res
          // 布局填充
          if (res.length % 3 === 2) {
            this.dirList.push({ id: '0', picture: '', name: '' })
          }
          this.dirList.forEach(item => {
            item.checked = true
          })
          this.changeDirectory(res[0])
        } else {
          this.dirList = []
          this.selectDirectory = {}
          // this.$refs.fileTab.getFileList()
        }
      }).finally(() => {
        this.loadingDirListData = false
      })
    },
    // 勾选/取消勾选工位文件
    toggleCheck(e: any, dir: any) {
      dir.checked = e.target.checked
      this.dirList = [...this.dirList]
    },
    // 切换设备目录
    changeDirectory(data: any) {
      this.selectDirectory = data
      data.checked = true
      // 清空勾选，只保留当前选中的目录
      this.dirList.filter(item => item.id !== data.id).map(item => item.checked = false)
      this.dirList = [...this.dirList]
      /* this.$nextTick(()=>{
         this.$refs.fileTab.getFileList()
       })*/
    },
    // 关闭上传文件的弹框
    closeUploadModal(reload?: boolean) {
      this.uploadModalVisible = false
      if (reload) {
        this.$refs.fileTab.getFileList()
        this.updateLog()
      }
    },
    // 更新日志
    updateLog() {
      if (this.$refs.log)
        console.log('更新日志')
        this.$refs.log&&this.$refs.log.getTableData()
    },
    // 获取回传文件
    getTurnAoundFile(data: any) {
      this.turnAroundDoc = data
    },
    // 删除回传文件，刷新列表
    deleteFile(data: any) {
      this.$refs.fileTab.handleDelete(data)
    }
  }
})
